
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries",
      function () {
        return require("private-next-pages/industries/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industries"])
      });
    }
  